// ==========================================================
// File: src/pages/chatStorage.js
// ==========================================================

const CHAT_KEY = 'chatSupportConversations';
const EXPIRY_DAYS = 2;
const MS_IN_DAY = 24 * 60 * 60 * 1000;

export const cleanExpiredChats = () => {
    const storedData = localStorage.getItem(CHAT_KEY);
    if (!storedData) return;
    try {
        const chats = JSON.parse(storedData);
        const expiryTime = Date.now() - (EXPIRY_DAYS * MS_IN_DAY);
        let changed = false;

        Object.keys(chats).forEach(userId => {
            const filteredMessages = chats[userId].filter(msg => msg.timestamp > expiryTime);
            if (filteredMessages.length !== chats[userId].length || filteredMessages.length === 0) {
                chats[userId] = filteredMessages;
                changed = true;
                if (filteredMessages.length === 0) delete chats[userId];
            }
        });
        if (changed) { localStorage.setItem(CHAT_KEY, JSON.stringify(chats)); }
    } catch (e) {
        console.error("Error cleaning chat data from LocalStorage", e);
        localStorage.removeItem(CHAT_KEY);
    }
};

export const loadChats = () => {
    cleanExpiredChats();
    const storedData = localStorage.getItem(CHAT_KEY);
    if (!storedData) return {};
    try {
        return JSON.parse(storedData);
    } catch (e) {
        console.error("Error loading chat data from LocalStorage", e);
        return {};
    }
};

export const saveMessage = (userId, message) => {
    const chats = loadChats();
    if (!chats[userId]) {
        chats[userId] = [];
    }
    chats[userId].push(message);
    localStorage.setItem(CHAT_KEY, JSON.stringify(chats));
};